import { render, staticRenderFns } from "./basicComponent.vue?vue&type=template&id=c8213c3c&scoped=true"
import script from "./basicComponent.vue?vue&type=script&lang=js"
export * from "./basicComponent.vue?vue&type=script&lang=js"
import style0 from "./basicComponent.vue?vue&type=style&index=0&id=c8213c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8213c3c",
  null
  
)

export default component.exports